import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Button,
  //Modal,
  Dialog,
  IconButton,
  AppBar,
  Toolbar,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  Grid,
  TextField,
  Divider,
  Paper,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { fetchEmployees } from "../../../api/employeeUtils"; // Updated import path
import BackWithArrow from "../../common/BackWithArrow";
import GlobalButton from "../../common/GlobalButton"; // Updated import path
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import SaveIcon from "@mui/icons-material/Save";
import { fetchAuditList } from "../../../api/FetchAuditList";
import CARCreateDialog from "../../CAR&PAR/CARComponents/CARCreateDialog"; // Import the CAR dialog component
//
export default function AuditModal({
  open,
  onClose,
  title,
  setTitle,
  recordStage,
  setRecordStage,
  auditStatus,
  setAuditStatus,
  audits,
  setAudits,
  //onRefresh, // Add this prop
  onSave,
  selectedDate, // Add selectedDate as a prop
}) {
  const [error, setError] = useState({});
  const [loading, setLoading] = useState(false); // Track loading state
  const [qualityOwner, setQualityOwner] = useState(""); // Add state for quality owner
  const [employees, setEmployees] = useState([]); // Add state for employees
  const [qualityOrigin, setQualityOrigin] = useState(""); // Add state for quality origin

  // State for Description section
  const [description, setDescription] = useState("");

  // States for Clause 4.3: Scope
  const [scopeAccurate, setScopeAccurate] = useState("");
  const [activitiesCovered, setActivitiesCovered] = useState("");

  // States for Clause 4.4: Process review
  const [qmsAccurate, setQmsAccurate] = useState("");
  const [inputsOutputs, setInputsOutputs] = useState("");
  const [processResources, setProcessResources] = useState("");
  const [peopleAssigned, setPeopleAssigned] = useState("");
  const [correctiveAction, setCorrectiveAction] = useState("");
  const [processImprovement, setProcessImprovement] = useState("");

  // // States for Clause 5.3: Roles and responsibilities
  const [rolesResponsibilities, setRolesResponsibilities] = useState("");

  // States for Clause 8.1: Process review
  const [processesPlanned, setProcessesPlanned] = useState("");
  const [outsourcedProcesses, setOutsourcedProcesses] = useState("");
  const [inspectionCriteria, setInspectionCriteria] = useState("");
  const [supportProcedures, setSupportProcedures] = useState("");

  // States for Clause 8.2.1: Quoting
  const [quotingProcedure, setQuotingProcedure] = useState("");
  const [customerQuestions, setCustomerQuestions] = useState("");

  // States for Clause 8.2.2: Customer requirements
  const [customerRequirementsCaptured, setCustomerRequirementsCaptured] =
    useState("");
  const [requirementsReviewed, setRequirementsReviewed] = useState("");

  // States for Clause 8.2.3: Customer requirements
  const [applicableRequirements, setApplicableRequirements] = useState("");
  const [quoteReviewed, setQuoteReviewed] = useState("");

  // States for Clause 8.2.4: Order entry
  const [changeAgreed, setChangeAgreed] = useState("");
  const [changesDocumented, setChangesDocumented] = useState("");

  // States for Clause 8.3: Customer Design
  const [acceptingProcedure, setAcceptingProcedure] = useState("");
  const [designRecords, setDesignRecords] = useState("");
  const [designReview, setDesignReview] = useState("");
  const [designChanges, setDesignChanges] = useState("");
  const [designApproval, setDesignApproval] = useState("");
  const [nonconformityPrevention, setNonconformityPrevention] = useState("");

  // Add state variables for Clause 8.4: Purchasing
  const [supplierControls, setSupplierControls] = useState("");
  const [supplierEvaluations, setSupplierEvaluations] = useState("");
  const [evaluationRecords, setEvaluationRecords] = useState("");
  const [receivingInspection, setReceivingInspection] = useState("");
  const [poReviews, setPoReviews] = useState("");
  const [poInformation, setPoInformation] = useState("");

  // Add state variables for Clause 8.5: Production
  const [productInfo, setProductInfo] = useState("");
  const [inspectionDevices, setInspectionDevices] = useState("");
  const [inProcessInspections, setInProcessInspections] = useState("");
  const [facilitiesEquipment, setFacilitiesEquipment] = useState("");
  const [operatorTraining, setOperatorTraining] = useState("");
  const [productIdentification, setProductIdentification] = useState("");
  const [inspectionStatus, setInspectionStatus] = useState("");
  const [propertyOwner, setPropertyOwner] = useState("");
  const [shelfLifeItems, setShelfLifeItems] = useState("");
  const [productHandling, setProductHandling] = useState("");
  const [productStorage, setProductStorage] = useState("");
  const [postDeliveryWork, setPostDeliveryWork] = useState("");
  const [customerComplaints, setCustomerComplaints] = useState("");
  const [processChanges, setProcessChanges] = useState("");
  //
  const [submitting, setSubmitting] = useState(false);
  //
  // add state variable for Clause 8.6:  Final inspection
  const [
    finalinspectionsORtestsConducted,
    setFinalinspectionsortestsConducted,
  ] = useState(""); // Initialize state for final inspection procedure
  const [finalinspectionrecordskept, setFinalinspectionrecordsKept] =
    useState(""); // Initialize state for final inspection records
  const [finalinspectionrecordsinclude, setFinalinspectionRecordsInclude] =
    useState("");

  // add state variable for Clause 8.7:  Non-conforming product
  const [
    nonconformingproductsproperlyidentified,
    setnonConformingProductsproperlyidentified,
  ] = useState("");
  const [doesthecompanynotifycustomers, setdoesThecompanyNotifycustomers] =
    useState("");
  const [nonconformingproductdealtwith, setnonConformingproductDealtwith] =
    useState("");
  const [
    nonconformingproductsegregatedor,
    setnonConformingProductsegregatedor,
  ] = useState("");
  const [customernotifiedwhenapplicable, setcustomerNotifiedWhenapplicable] =
    useState("");
  const [productisreworkedorrepaired, setproductisREworkedORrepaired] =
    useState("");
  const [recordsofthenonconformities, setrecordsOFthenonConformities] =
    useState("");
  const [customerapprovalsorwaivers, setcustomerApprovalsORwaivers] =
    useState("");
  //
  // States for Clause 9.1:  Business performance
  const [methodsunderwaytomonitor, setmethodsUnderwayTomonitor] = useState("");
  const [companymeasuringproduct, setcompanyMeasuringProduct] = useState("");
  const [companykpi, setcompanyKpi] = useState("");
  const [suppliersbeingmeasured, setsuppliersBeingMeasured] = useState("");

  // Fetch employees when the component mounts
  useEffect(() => {
    const loadEmployees = async () => {
      try {
        const employeeData = await fetchEmployees();
        console.log("Employees loaded:", employeeData);
        setEmployees(employeeData || []);
      } catch (error) {
        console.error("Failed to load employees:", error);
      }
    };

    loadEmployees();
  }, []);

  // Function to handle the save action
  const handleSave = async () => {
    //alert("Record saved successfully");
    console.log("Save button clicked");
    if (loading) return; // Prevent multiple submissions
    setSubmitting(true);

    const newError = {};
    if (!recordStage || recordStage === "Select Record Stage") {
      newError.recordStage = "Record Stage is required.";
    }
    if (!title.trim() || title === "Select Title") {
      newError.title = "Title is required.";
    }
    if (!auditStatus || auditStatus === "Select Audit Status") {
      newError.auditStatus = "Audit Status is required.";
    }
    if (
      !selectedDate ||
      !(selectedDate instanceof Date) ||
      isNaN(selectedDate.getTime())
    ) {
      newError.date = "A valid date is required."; // Ensure a valid date is selected
    }
    if (!qualityOwner || qualityOwner === "") {
      newError.qualityOwner = "Quality owner is required.";
    }

    if (Object.keys(newError).length > 0) {
      setError(newError);
      return;
    }

    setError({});

    // Find the selected employee to log their details
    const selectedEmployee = employees.find((emp) => emp.ID === qualityOwner);
    console.log(
      "Selected employee:",
      selectedEmployee ? selectedEmployee.Name.zc_display_value : "None",
      "with ID:",
      qualityOwner
    );

    const auditData = {
      title,
      recordStage,
      auditStatus,
      date: selectedDate, // Use the selected date from the calendar
      qualityOwner, // Add quality owner to audit data
      qualityOrigin, // Add quality origin to audit data
      // Add Description section
      description,
      // Add Clause 4.3: Scope fields
      scopeAccurate,
      activitiesCovered,
      // Add Clause 4.4: Process review fields
      qmsAccurate,
      inputsOutputs,
      processResources,
      peopleAssigned,
      correctiveAction,
      processImprovement,
      // // Add Clause 5.3: Roles and responsibilities fields
      rolesResponsibilities,
      // Add Clause 8.1: Process review fields
      processesPlanned,
      outsourcedProcesses,
      inspectionCriteria,
      supportProcedures,
      // Add Clause 8.2.1: Quoting fields
      quotingProcedure,
      customerQuestions,
      // Add Clause 8.2.2: Customer requirements fields
      customerRequirementsCaptured,
      requirementsReviewed,
      // Add Clause 8.2.3: Customer requirements fields
      applicableRequirements,
      quoteReviewed,
      // Add Clause 8.2.4: Order entry fields
      changeAgreed,
      changesDocumented,
      // Add Clause 8.3: Customer Design fields
      acceptingProcedure,
      designRecords,
      designReview,
      designChanges,
      designApproval,
      nonconformityPrevention,
      // Add Clause 8.4: Purchasing fields
      supplierControls,
      supplierEvaluations,
      evaluationRecords,
      receivingInspection,
      poReviews,
      poInformation,
      // Add Clause 8.5: Production fields
      productInfo,
      inspectionDevices,
      inProcessInspections,
      facilitiesEquipment,
      operatorTraining,
      productIdentification,
      inspectionStatus,
      propertyOwner,
      shelfLifeItems,
      productHandling,
      productStorage,
      postDeliveryWork,
      customerComplaints,
      processChanges,
      // Add Clause 8.6: Final inspection fields
      finalinspectionsORtestsConducted,
      finalinspectionrecordskept,
      finalinspectionrecordsinclude,
      // Add Clause 8.7: Non-conforming product fields
      nonconformingproductsproperlyidentified,
      doesthecompanynotifycustomers,
      nonconformingproductdealtwith,
      nonconformingproductsegregatedor,
      customernotifiedwhenapplicable,
      productisreworkedorrepaired,
      recordsofthenonconformities,
      customerapprovalsorwaivers,
      // Add Clause 9.1: Business performance fields
      methodsunderwaytomonitor,
      companymeasuringproduct,
      companykpi,
      suppliersbeingmeasured,
    };

    try {
      setLoading(true);
      // Call the onSave function passed from parent
      const result = await onSave(auditData);
      if (result) {
        // Success - modal will be closed by parent component
        setError({});
      }
    } catch (error) {
      console.error("Error saving audit:", error);
    } finally {
      setLoading(false);
      setSubmitting(false);
    }
  };

  // Add state for CAR dialog
  const [carDialogOpen, setCarDialogOpen] = useState(false);
  const [carFormData, setCarFormData] = useState({
    name: "",
    date: new Date().toISOString().split("T")[0], // Today's date
    type: "corrective",
    Source: "InternalAuditFinding",
    // Other initial form values
  });

  // Handler for CAR form input changes
  const handleCarInputChange = (field, value) => {
    setCarFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  // Function to open the CAR dialog
  const handleOpenCarDialog = () => {
    // Pre-populate data from the audit if needed
    setCarFormData((prev) => ({
      ...prev,
      name: `CAR from ${title} Audit`, // Example of using audit data
      // You can add more pre-populated fields here
    }));
    setCarDialogOpen(true);
  };

  return (
    <Dialog
      open={open}
      fullScreen
      PaperProps={{
        sx: {
          minHeight: "100vh",
          maxHeight: "100vh",
          background: "white", // Remove background
        },
      }}
    >
      <BackWithArrow onBack={onClose} />
      <Box sx={{ p: 4 }}>
        <Grid container spacing={1} sx={{ mb: 2 }}>
          <Grid item xs={12} sm={2.4} md={2.4} lg={2.4}>
            <FormControl fullWidth size="small" error={!!error.title}>
              <InputLabel>Title</InputLabel>
              <Select
                value={title || "Select Title"}
                onChange={(e) => setTitle(e.target.value)}
                label="Title"
              >
                <MenuItem value="Select Title" disabled>
                  Select Title
                </MenuItem>
                <MenuItem value="Estimating, Work scheduling and Art Setup">
                  Estimating, Work scheduling and Art Setup
                </MenuItem>
                <MenuItem value="Purchasing, Receiving, Shipping">
                  Purchasing, Receiving, Shipping
                </MenuItem>
                <MenuItem value="Printing and Finishing">
                  Printing and Finishing
                </MenuItem>
                <MenuItem value="Installation">Installation</MenuItem>
              </Select>
              {error.title && (
                <Typography variant="caption" color="error">
                  {error.title}
                </Typography>
              )}
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={2.4} md={2.4} lg={2.4}>
            <FormControl fullWidth size="small" error={!!error.recordStage}>
              <InputLabel>Record Stage</InputLabel>
              <Select
                value={recordStage || "Select Record Stage"}
                onChange={(e) => setRecordStage(e.target.value)}
                label="Record Stage"
              >
                <MenuItem value="Select Record Stage" disabled>
                  Select Record Stage
                </MenuItem>
                <MenuItem value="Current Record">Current record</MenuItem>
                <MenuItem value="Future Record">Future record</MenuItem>
              </Select>
              {error.recordStage && (
                <Typography variant="caption" color="error">
                  {error.recordStage}
                </Typography>
              )}
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={2.4} md={2.4} lg={2.4}>
            <FormControl fullWidth size="small" error={!!error.auditStatus}>
              <InputLabel>Audit Status</InputLabel>
              <Select
                value={auditStatus || "Select Audit Status"}
                onChange={(e) => setAuditStatus(e.target.value)}
                label="Audit Status"
              >
                <MenuItem value="Select Audit Status" disabled>
                  Select Audit Status
                </MenuItem>
                <MenuItem value="Planned">Planned</MenuItem>
                <MenuItem value="Scheduled">Scheduled</MenuItem>
                <MenuItem value="In-process">In-process</MenuItem>
                <MenuItem value="Completed">Completed</MenuItem>
                <MenuItem value="Cancelled">Cancelled</MenuItem>
              </Select>
              {error.auditStatus && (
                <Typography variant="caption" color="error">
                  {error.auditStatus}
                </Typography>
              )}
            </FormControl>
          </Grid>

          <Grid item xs={12} sm={2.4} md={2.4} lg={2.4}>
            <FormControl fullWidth size="small" error={!!error.qualityOwner}>
              <InputLabel>Quality Owner</InputLabel>
              <Select
                value={qualityOwner || ""}
                onChange={(e) => {
                  const value = e.target.value;
                  console.log("Selected quality owner ID:", value);
                  setQualityOwner(value);
                }}
                label="Quality Owner"
              >
                <MenuItem value="" disabled>
                  Select Quality Owner
                </MenuItem>
                {employees && employees.length > 0 ? (
                  employees.map((employee) => (
                    <MenuItem key={employee.ID} value={employee.ID}>
                      {employee.Name.zc_display_value}
                    </MenuItem>
                  ))
                ) : (
                  <MenuItem value="" disabled>
                    No employees found
                  </MenuItem>
                )}
              </Select>
              {error.qualityOwner && (
                <Typography variant="caption" color="error">
                  {error.qualityOwner}
                </Typography>
              )}
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={2.4} md={2.4} lg={2.4}>
            <FormControl fullWidth size="small">
              <InputLabel>Quality Origin</InputLabel>
              <Select
                value={qualityOrigin || ""}
                onChange={(e) => setQualityOrigin(e.target.value)}
                label="Quality Origin"
              >
                <MenuItem value="" disabled>
                  Select Quality Origin
                </MenuItem>
                <MenuItem value="Email">Email</MenuItem>
                <MenuItem value="Phone">Phone</MenuItem>
                <MenuItem value="Web">Web</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={2.4} md={2.4} lg={2.4}>
            <GlobalButton
              sx={{ mr: 2 }}
              variant="contained"
              onClick={handleOpenCarDialog}
            >
              Create CAR
            </GlobalButton>
          </Grid>
        </Grid>
        {/* Description information */}
        <Accordion defaultExpanded>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            sx={{
              backgroundColor: "#f5f5f5",
              borderBottom: "1px solid #e0e0e0",
            }}
          >
            <Typography variant="h6">Description information</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Grid container spacing={2}>
              <Grid item sx={{ width: "500px", mt: 2 }}>
                <TextField
                  fullWidth
                  label="Description"
                  multiline
                  rows={4}
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                  variant="outlined"
                  sx={{ mb: 2 }}
                />
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>
        {/* Clause 4.3: Scope */}
        <Accordion defaultExpanded>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            sx={{
              backgroundColor: "#f5f5f5",
              borderBottom: "1px solid #e0e0e0",
            }}
          >
            <Typography variant="h6">Clause 4.3: Scope</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Grid container spacing={3}>
              <Grid item sx={{ width: "500px" }}>
                <Typography
                  variant="subtitle1"
                  sx={{ mb: 1, fontWeight: "medium", mt: 2 }}
                >
                  1. Is the scope statement in the QMS still accurate?
                </Typography>
                <TextField
                  fullWidth
                  multiline
                  rows={3}
                  value={scopeAccurate}
                  onChange={(e) => setScopeAccurate(e.target.value)}
                  variant="outlined"
                  sx={{ mb: 1 }}
                />
              </Grid>
              <Grid item sx={{ width: "500px" }}>
                <Typography
                  variant="subtitle1"
                  sx={{ mb: 1, fontWeight: "medium", mt: 2 }}
                >
                  2. Are all applicable activities covered by the QMS scope?
                </Typography>
                <TextField
                  fullWidth
                  multiline
                  rows={3}
                  value={activitiesCovered}
                  onChange={(e) => setActivitiesCovered(e.target.value)}
                  variant="outlined"
                  sx={{ mb: 2 }}
                />
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>
        {/* Clause 4.4: Process review */}
        <Accordion defaultExpanded>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            sx={{
              backgroundColor: "#f5f5f5",
              borderBottom: "1px solid #e0e0e0",
            }}
          >
            <Typography variant="h6">Clause 4.4: Process review</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Grid container spacing={3}>
              <Grid item sx={{ width: "500px" }}>
                <Typography
                  variant="subtitle1"
                  sx={{ mb: 2.5, fontWeight: "medium", mt: 4 }}
                >
                  1. Is the QMS accurate re: the top-level processes are
                  identified?
                </Typography>
                <TextField
                  fullWidth
                  multiline
                  rows={3}
                  value={qmsAccurate}
                  onChange={(e) => setQmsAccurate(e.target.value)}
                  variant="outlined"
                />
              </Grid>
              <Grid item sx={{ width: "500px" }}>
                <Typography
                  variant="subtitle1"
                  sx={{ mb: 1, fontWeight: "medium", mt: 2 }}
                >
                  2. Are inputs and outputs defined in some manner for each
                  top-level process?
                </Typography>
                <TextField
                  fullWidth
                  multiline
                  rows={3}
                  value={inputsOutputs}
                  onChange={(e) => setInputsOutputs(e.target.value)}
                  variant="outlined"
                />
              </Grid>
              <Grid item sx={{ width: "500px" }}>
                <Typography variant="subtitle1" sx={{ fontWeight: "medium" }}>
                  3. Are process resources (people, facilities and equipment)
                  <br></br> provided as necessary?
                </Typography>
                <TextField
                  fullWidth
                  multiline
                  rows={3}
                  value={processResources}
                  onChange={(e) => setProcessResources(e.target.value)}
                  variant="outlined"
                />
              </Grid>
              <Grid item sx={{ width: "500px" }}>
                <Typography
                  variant="subtitle1"
                  sx={{ mb: 0, fontWeight: "medium" }}
                >
                  4. Does each top-level process have people assigned
                  responsibility and authority?
                </Typography>
                <TextField
                  fullWidth
                  multiline
                  rows={3}
                  value={peopleAssigned}
                  onChange={(e) => setPeopleAssigned(e.target.value)}
                  variant="outlined"
                />
              </Grid>
              <Grid item sx={{ width: "500px" }}>
                <Typography variant="subtitle1" sx={{ fontWeight: "medium" }}>
                  5. If a process doesn't meet a goal or measurement, is
                  corrective <br></br> action taken?
                </Typography>
                <TextField
                  fullWidth
                  multiline
                  rows={3}
                  value={correctiveAction}
                  onChange={(e) => setCorrectiveAction(e.target.value)}
                  variant="outlined"
                />
              </Grid>
              <Grid item sx={{ width: "500px" }}>
                <Typography
                  variant="subtitle1"
                  sx={{ mb: 3.3, fontWeight: "medium" }}
                >
                  6. Does management seek to improve the processes over time?
                </Typography>
                <TextField
                  fullWidth
                  multiline
                  rows={3}
                  value={processImprovement}
                  onChange={(e) => setProcessImprovement(e.target.value)}
                  variant="outlined"
                  sx={{ mb: 2 }}
                />
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>
        {/* Clause 5.3: Roles and responsibilities */}
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            sx={{
              backgroundColor: "#f5f5f5",
              borderBottom: "1px solid #e0e0e0",
            }}
          >
            <Typography variant="h6">
              Clause 5.3: Roles and responsibilities
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Grid container spacing={3}>
              <Grid item sx={{ width: "500px" }}>
                <Typography
                  variant="subtitle1"
                  sx={{ mb: 1, fontWeight: "medium", mt: 2 }}
                >
                  1. Are company roles and responsibilities defined and
                  communicated through the company?
                </Typography>
                <TextField
                  fullWidth
                  multiline
                  rows={3}
                  value={rolesResponsibilities}
                  onChange={(e) => setRolesResponsibilities(e.target.value)}
                  variant="outlined"
                  sx={{ mb: 2 }}
                />
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>
        {/* Clause 8.1:  Process review  */}
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            sx={{
              backgroundColor: "#f5f5f5",
              borderBottom: "1px solid #e0e0e0",
            }}
          >
            <Typography variant="h6">Clause 8.1: Process review </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Grid container spacing={3}>
              <Grid item sx={{ width: "500px" }}>
                <Typography
                  variant="subtitle1"
                  sx={{ mb: 1, fontWeight: "medium", mt: 2 }}
                >
                  1. Are the processes planned with an eye towards the
                  customer’s product requirements?
                </Typography>
                <TextField
                  fullWidth
                  multiline
                  rows={3}
                  value={processesPlanned}
                  onChange={(e) => setProcessesPlanned(e.target.value)}
                  variant="outlined"
                />
              </Grid>
              <Grid item sx={{ width: "500px" }}>
                <Typography
                  variant="subtitle1"
                  sx={{ mb: 2.2, fontWeight: "medium", mt: 4 }}
                >
                  2. Are outsourced processes controlled?
                </Typography>
                <TextField
                  fullWidth
                  multiline
                  rows={3}
                  value={outsourcedProcesses}
                  onChange={(e) => setOutsourcedProcesses(e.target.value)}
                  variant="outlined"
                />
              </Grid>
              <Grid item sx={{ width: "500px" }}>
                <Typography
                  variant="subtitle1"
                  sx={{ mb: 2.7, fontWeight: "medium", mt: 2 }}
                >
                  3. Are the inspection/test criteria for product defined?
                </Typography>
                <TextField
                  fullWidth
                  multiline
                  rows={3}
                  value={inspectionCriteria}
                  onChange={(e) => setInspectionCriteria(e.target.value)}
                  variant="outlined"
                  sx={{ mb: 2 }}
                />
              </Grid>
              <Grid item sx={{ width: "500px" }}>
                <Typography
                  variant="subtitle1"
                  sx={{ mb: 1, fontWeight: "medium" }}
                >
                  4. Are procedures developed to support manufacturing processes
                  (where needed)?
                </Typography>
                <TextField
                  fullWidth
                  multiline
                  rows={3}
                  value={supportProcedures}
                  onChange={(e) => setSupportProcedures(e.target.value)}
                  variant="outlined"
                  sx={{ mb: 2 }}
                />
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>
        {/* Clause 8.2.1: Quoting */}
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            sx={{
              backgroundColor: "#f5f5f5",
              borderBottom: "1px solid #e0e0e0",
            }}
          >
            <Typography variant="h6">Clause 8.2.1: Quoting</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Grid container spacing={3}>
              <Grid item sx={{ width: "500px" }}>
                <Typography
                  variant="subtitle1"
                  sx={{ mb: 2.7, fontWeight: "medium", mt: 4 }}
                >
                  1. Is the procedure for quoting up to date and being followed?
                </Typography>
                <TextField
                  fullWidth
                  multiline
                  rows={3}
                  value={quotingProcedure}
                  onChange={(e) => setQuotingProcedure(e.target.value)}
                  variant="outlined"
                  sx={{ mb: 2 }}
                />
              </Grid>
              <Grid item sx={{ width: "500px" }}>
                <Typography
                  variant="subtitle1"
                  sx={{ mb: 1, fontWeight: "medium", mt: 2 }}
                >
                  2. Are customer questions related to jobs, products, etc.
                  routed and processed in an appropriate way?
                </Typography>
                <TextField
                  fullWidth
                  multiline
                  rows={3}
                  value={customerQuestions}
                  onChange={(e) => setCustomerQuestions(e.target.value)}
                  variant="outlined"
                  sx={{ mb: 2 }}
                />
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>
        {/* Clause 8.2.2: Customer requirements */}
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            sx={{
              backgroundColor: "#f5f5f5",
              borderBottom: "1px solid #e0e0e0",
            }}
          >
            <Typography variant="h6">
              Clause 8.2.2: Customer requirements
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Grid container spacing={3}>
              <Grid item sx={{ width: "500px" }}>
                <Typography
                  variant="subtitle1"
                  sx={{ mb: 4.5, fontWeight: "medium", mt: 2 }}
                >
                  1. Are customer requirements for product captured accurately?
                </Typography>
                <TextField
                  fullWidth
                  multiline
                  rows={3}
                  value={customerRequirementsCaptured}
                  onChange={(e) =>
                    setCustomerRequirementsCaptured(e.target.value)
                  }
                  variant="outlined"
                  sx={{ mb: 2 }}
                />
              </Grid>
              <Grid item sx={{ width: "500px" }}>
                <Typography
                  variant="subtitle1"
                  sx={{ mb: 1, fontWeight: "medium", mt: 2 }}
                >
                  2. Are these requirements reviewed before the company commits
                  to delivering the products?
                </Typography>
                <TextField
                  fullWidth
                  multiline
                  rows={3}
                  value={requirementsReviewed}
                  onChange={(e) => setRequirementsReviewed(e.target.value)}
                  variant="outlined"
                  sx={{ mb: 2 }}
                />
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>
        {/* Clause 8.2.3: Customer requirements */}
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            sx={{
              backgroundColor: "#f5f5f5",
              borderBottom: "1px solid #e0e0e0",
            }}
          >
            <Typography variant="h6">
              Clause 8.2.3: Customer requirements
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Grid container spacing={3}>
              <Grid item sx={{ width: "500px" }}>
                <Typography
                  variant="subtitle1"
                  sx={{ mb: 4.6, fontWeight: "medium", mt: 2 }}
                >
                  1. Does this review include the applicable requirements?
                </Typography>
                <TextField
                  fullWidth
                  multiline
                  rows={4}
                  value={applicableRequirements}
                  onChange={(e) => setApplicableRequirements(e.target.value)}
                  variant="outlined"
                  sx={{ mb: 2 }}
                />
              </Grid>
              <Grid item sx={{ width: "500px" }}>
                <Typography
                  variant="subtitle1"
                  sx={{ mb: 1, fontWeight: "medium", mt: 2 }}
                >
                  2. If a quote was prepared previously, is this reviewed
                  against the incoming order and any deviations resolved with
                  the customer?
                </Typography>
                <TextField
                  fullWidth
                  multiline
                  rows={4}
                  value={quoteReviewed}
                  onChange={(e) => setQuoteReviewed(e.target.value)}
                  variant="outlined"
                  sx={{ mb: 2 }}
                />
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>
        {/* Clause 8.2.4: Order entry */}
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            sx={{
              backgroundColor: "#f5f5f5",
              borderBottom: "1px solid #e0e0e0",
            }}
          >
            <Typography variant="h6">Clause 8.2.4: Order entry</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Grid container spacing={3}>
              <Grid item sx={{ width: "500px" }}>
                <Typography
                  variant="subtitle1"
                  sx={{ mb: 1, fontWeight: "medium", mt: 2 }}
                >
                  1. If either the customer or the company changes the order
                  requirements after it's been taken, is this change agreed to
                  with the customer?
                </Typography>
                <TextField
                  fullWidth
                  multiline
                  rows={4}
                  value={changeAgreed}
                  onChange={(e) => setChangeAgreed(e.target.value)}
                  variant="outlined"
                  sx={{ mb: 2 }}
                />
              </Grid>
              <Grid item sx={{ width: "500px" }}>
                <Typography
                  variant="subtitle1"
                  sx={{ mb: 4.8, fontWeight: "medium", mt: 5 }}
                >
                  2. Are changes to all necessary orders documented?
                </Typography>
                <TextField
                  fullWidth
                  multiline
                  rows={4}
                  value={changesDocumented}
                  onChange={(e) => setChangesDocumented(e.target.value)}
                  variant="outlined"
                  sx={{ mb: 2 }}
                />
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>
        {/* Clause 8.3: Customer Design */}
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            sx={{
              backgroundColor: "#f5f5f5",
              borderBottom: "1px solid #e0e0e0",
            }}
          >
            <Typography variant="h6">Clause 8.3: Customer Design</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Grid container spacing={3}>
              <Grid item sx={{ width: "500px" }}>
                <Typography
                  variant="subtitle1"
                  sx={{ mb: 1, fontWeight: "medium", mt: 2 }}
                >
                  1. Is the procedure for accepting customer design being
                  followed?
                </Typography>
                <TextField
                  fullWidth
                  multiline
                  rows={3}
                  value={acceptingProcedure}
                  onChange={(e) => setAcceptingProcedure(e.target.value)}
                  variant="outlined"
                />
              </Grid>
              <Grid item sx={{ width: "500px" }}>
                <Typography
                  variant="subtitle1"
                  sx={{ mb: 1, fontWeight: "medium", mt: 2 }}
                >
                  2. Are there records of the accepting customer design?
                </Typography>
                <TextField
                  fullWidth
                  multiline
                  rows={3}
                  value={designRecords}
                  onChange={(e) => setDesignRecords(e.target.value)}
                  variant="outlined"
                />
              </Grid>
              <Grid item sx={{ width: "500px" }}>
                <Typography
                  variant="subtitle1"
                  sx={{ mb: 1, fontWeight: "medium" }}
                >
                  3. Do activities include necessary review of customer provided
                  designs?
                </Typography>
                <TextField
                  fullWidth
                  multiline
                  rows={3}
                  value={designReview}
                  onChange={(e) => setDesignReview(e.target.value)}
                  variant="outlined"
                />
              </Grid>
              <Grid item sx={{ width: "500px" }}>
                <Typography
                  variant="subtitle1"
                  sx={{ mb: 2.4, fontWeight: "medium", mt: 2 }}
                >
                  4. Are there records kept if a customer changes design?
                </Typography>
                <TextField
                  fullWidth
                  multiline
                  rows={3}
                  value={designChanges}
                  onChange={(e) => setDesignChanges(e.target.value)}
                  variant="outlined"
                />
              </Grid>
              <Grid item sx={{ width: "500px" }}>
                <Typography
                  variant="subtitle1"
                  sx={{ mb: 1, fontWeight: "medium" }}
                >
                  5. Are there records kept on approval by customers of the
                  design?
                </Typography>
                <TextField
                  fullWidth
                  multiline
                  rows={3}
                  value={designApproval}
                  onChange={(e) => setDesignApproval(e.target.value)}
                  variant="outlined"
                  sx={{ mb: 2 }}
                />
              </Grid>
              <Grid item sx={{ width: "500px" }}>
                <Typography
                  variant="subtitle1"
                  sx={{ mb: 1, fontWeight: "medium" }}
                >
                  6. Are there records of any actions taken to prevent
                  nonconformities?
                </Typography>
                <TextField
                  fullWidth
                  multiline
                  rows={3}
                  value={nonconformityPrevention}
                  onChange={(e) => setNonconformityPrevention(e.target.value)}
                  variant="outlined"
                  sx={{ mb: 2 }}
                />
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>
        {/* Clause 8.4: Purchasing */}
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            sx={{
              backgroundColor: "#f5f5f5",
              borderBottom: "1px solid #e0e0e0",
            }}
          >
            <Typography variant="h6">Clause 8.4: Purchasing</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Grid container spacing={3}>
              <Grid item sx={{ width: "500px" }}>
                <Typography
                  variant="subtitle1"
                  sx={{ mb: 1, fontWeight: "medium", mt: 2 }}
                >
                  1. Are suppliers subject to controls to ensure the quality of
                  purchased products?
                </Typography>
                <TextField
                  fullWidth
                  multiline
                  rows={3}
                  value={supplierControls}
                  onChange={(e) => setSupplierControls(e.target.value)}
                  variant="outlined"
                />
              </Grid>
              <Grid item sx={{ width: "500px" }}>
                <Typography
                  variant="subtitle1"
                  sx={{ mb: 1, fontWeight: "medium", mt: 2 }}
                >
                  2. Are suppliers evaluated against some criteria to ensure
                  they meet company expectations for quality?
                </Typography>
                <TextField
                  fullWidth
                  multiline
                  rows={3}
                  value={supplierEvaluations}
                  onChange={(e) => setSupplierEvaluations(e.target.value)}
                  variant="outlined"
                />
              </Grid>
              <Grid item sx={{ width: "500px" }}>
                <Typography
                  variant="subtitle1"
                  sx={{ mb: 1, fontWeight: "medium" }}
                >
                  3. Are the records of supplier evaluations up to date and
                  accurate?
                </Typography>
                <TextField
                  fullWidth
                  multiline
                  rows={3}
                  value={evaluationRecords}
                  onChange={(e) => setEvaluationRecords(e.target.value)}
                  variant="outlined"
                />
              </Grid>
              <Grid item sx={{ width: "500px" }}>
                <Typography
                  variant="subtitle1"
                  sx={{ mb: 1, fontWeight: "medium" }}
                >
                  4. Are items inspected at receiving?
                </Typography>
                <TextField
                  fullWidth
                  multiline
                  rows={3}
                  value={receivingInspection}
                  onChange={(e) => setReceivingInspection(e.target.value)}
                  variant="outlined"
                />
              </Grid>
              <Grid item sx={{ width: "500px" }}>
                <Typography
                  variant="subtitle1"
                  sx={{ mb: 4.1, fontWeight: "medium", mt: 4 }}
                >
                  5. Are PO's reviewed before release to the supplier?
                </Typography>
                <TextField
                  fullWidth
                  multiline
                  rows={3}
                  value={poReviews}
                  onChange={(e) => setPoReviews(e.target.value)}
                  variant="outlined"
                />
              </Grid>
              <Grid item sx={{ width: "500px" }}>
                <Typography
                  variant="subtitle1"
                  sx={{ mb: 1, fontWeight: "medium" }}
                >
                  6. Do the outgoing PO's include all necessary information
                  about the items or services being purchased (description,
                  quantity, due date, etc.)?
                </Typography>
                <TextField
                  fullWidth
                  multiline
                  rows={3}
                  value={poInformation}
                  onChange={(e) => setPoInformation(e.target.value)}
                  variant="outlined"
                  sx={{ mb: 2 }}
                />
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>
        {/* Clause 8.5: Production */}
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            sx={{
              backgroundColor: "#f5f5f5",
              borderBottom: "1px solid #e0e0e0",
            }}
          >
            <Typography variant="h6">Clause 8.5: Production</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Grid container spacing={3}>
              <Grid item sx={{ width: "500px" }}>
                <Typography
                  variant="subtitle1"
                  sx={{ mb: 1, fontWeight: "medium", mt: 2 }}
                >
                  1. Are production operators provided with information
                  describing the product to be made?
                </Typography>
                <TextField
                  fullWidth
                  multiline
                  rows={3}
                  value={productInfo}
                  onChange={(e) => setProductInfo(e.target.value)}
                  variant="outlined"
                />
              </Grid>
              <Grid item sx={{ width: "500px" }}>
                <Typography
                  variant="subtitle1"
                  sx={{ mb: 1, fontWeight: "medium", mt: 2 }}
                >
                  2. Are suitable inspection devices provided which can be used
                  to inspect or test products?
                </Typography>
                <TextField
                  fullWidth
                  multiline
                  rows={3}
                  value={inspectionDevices}
                  onChange={(e) => setInspectionDevices(e.target.value)}
                  variant="outlined"
                />
              </Grid>
              <Grid item sx={{ width: "500px" }}>
                <Typography
                  variant="subtitle1"
                  sx={{ mb: 2.7, fontWeight: "medium", mt: 2 }}
                >
                  3. Are in-process inspections or tests conducted as required?
                </Typography>
                <TextField
                  fullWidth
                  multiline
                  rows={3}
                  value={inProcessInspections}
                  onChange={(e) => setInProcessInspections(e.target.value)}
                  variant="outlined"
                />
              </Grid>
              <Grid item sx={{ width: "500px" }}>
                <Typography
                  variant="subtitle1"
                  sx={{ mb: 1, fontWeight: "medium" }}
                >
                  4. Are the facilities and equipment adequate to ensure the
                  quality of the work?
                </Typography>
                <TextField
                  fullWidth
                  multiline
                  rows={3}
                  value={facilitiesEquipment}
                  onChange={(e) => setFacilitiesEquipment(e.target.value)}
                  variant="outlined"
                />
              </Grid>
              <Grid item sx={{ width: "500px" }}>
                <Typography
                  variant="subtitle1"
                  sx={{ mb: 2.6, fontWeight: "medium", mt: 2 }}
                >
                  5. Are operators trained as required?
                </Typography>
                <TextField
                  fullWidth
                  multiline
                  rows={3}
                  value={operatorTraining}
                  onChange={(e) => setOperatorTraining(e.target.value)}
                  variant="outlined"
                />
              </Grid>
              <Grid item sx={{ width: "500px" }}>
                <Typography
                  variant="subtitle1"
                  sx={{ mb: 1, fontWeight: "medium" }}
                >
                  6. Is product identified at all stages as to what it is and/or
                  what order it belongs to?
                </Typography>
                <TextField
                  fullWidth
                  multiline
                  rows={3}
                  value={productIdentification}
                  onChange={(e) => setProductIdentification(e.target.value)}
                  variant="outlined"
                />
              </Grid>
              <Grid item sx={{ width: "500px" }}>
                <Typography
                  variant="subtitle1"
                  sx={{ mb: 1, fontWeight: "medium" }}
                >
                  7. Does product identification include a means to identify its
                  inspection status?
                </Typography>
                <TextField
                  fullWidth
                  multiline
                  rows={3}
                  value={inspectionStatus}
                  onChange={(e) => setInspectionStatus(e.target.value)}
                  variant="outlined"
                />
              </Grid>
              <Grid item sx={{ width: "500px" }}>
                <Typography
                  variant="subtitle1"
                  sx={{ mb: 1, fontWeight: "medium" }}
                >
                  8. If the company uses customer or supplier provided hardware,
                  is this identified as the property owner?
                </Typography>
                <TextField
                  fullWidth
                  multiline
                  rows={3}
                  value={propertyOwner}
                  onChange={(e) => setPropertyOwner(e.target.value)}
                  variant="outlined"
                />
              </Grid>
              <Grid item sx={{ width: "500px" }}>
                <Typography
                  variant="subtitle1"
                  sx={{ mb: 1, fontWeight: "medium" }}
                >
                  9. Are shelf-life items only used if their expiration dates
                  have not expired?
                </Typography>
                <TextField
                  fullWidth
                  multiline
                  rows={3}
                  value={shelfLifeItems}
                  onChange={(e) => setShelfLifeItems(e.target.value)}
                  variant="outlined"
                />
              </Grid>
              <Grid item sx={{ width: "500px" }}>
                <Typography
                  variant="subtitle1"
                  sx={{ mb: 1, fontWeight: "medium" }}
                >
                  10. Is the product properly handled during all operations, to
                  prevent damage?
                </Typography>
                <TextField
                  fullWidth
                  multiline
                  rows={3}
                  value={productHandling}
                  onChange={(e) => setProductHandling(e.target.value)}
                  variant="outlined"
                />
              </Grid>
              <Grid item sx={{ width: "500px" }}>
                <Typography
                  variant="subtitle1"
                  sx={{ mb: 1, fontWeight: "medium" }}
                >
                  11. Is the product properly stored while awaiting use or
                  shipment, to prevent damage?
                </Typography>
                <TextField
                  fullWidth
                  multiline
                  rows={3}
                  value={productStorage}
                  onChange={(e) => setProductStorage(e.target.value)}
                  variant="outlined"
                />
              </Grid>
              <Grid item sx={{ width: "500px" }}>
                <Typography
                  variant="subtitle1"
                  sx={{ mb: 1, fontWeight: "medium" }}
                >
                  12. If the company does post-delivery work, does this address
                  related customer requirements?
                </Typography>
                <TextField
                  fullWidth
                  multiline
                  rows={3}
                  value={postDeliveryWork}
                  onChange={(e) => setPostDeliveryWork(e.target.value)}
                  variant="outlined"
                />
              </Grid>
              <Grid item sx={{ width: "500px" }}>
                <Typography
                  variant="subtitle1"
                  sx={{ mb: 2.7, fontWeight: "medium", mt: 2 }}
                >
                  13. Does post-delivery work address customer complaints or
                  feedback?
                </Typography>
                <TextField
                  fullWidth
                  multiline
                  rows={3}
                  value={customerComplaints}
                  onChange={(e) => setCustomerComplaints(e.target.value)}
                  variant="outlined"
                />
              </Grid>
              <Grid item sx={{ width: "500px" }}>
                <Typography
                  variant="subtitle1"
                  sx={{ mb: 1, fontWeight: "medium" }}
                >
                  14. Are changes to manufacturing processes only implemented
                  through a formal method that ensures the changes are reviewed
                  and authorized?
                </Typography>
                <TextField
                  fullWidth
                  multiline
                  rows={3}
                  value={processChanges}
                  onChange={(e) => setProcessChanges(e.target.value)}
                  variant="outlined"
                  sx={{ mb: 2 }}
                />
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>
        {/* Clause 8.6:  Final inspection */}
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            sx={{
              backgroundColor: "#f5f5f5",
              borderBottom: "1px solid #e0e0e0",
            }}
          >
            <Typography variant="h6">Clause 8.6: Final inspection</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Grid container spacing={3}>
              <Grid item sx={{ width: "500px" }}>
                <Typography
                  variant="subtitle1"
                  sx={{ mb: 1, fontWeight: "medium", mt: 2 }}
                >
                  1. Are final inspections or tests conducted to ensure the
                  product meets requirements before delivery?
                </Typography>
                <TextField
                  fullWidth
                  multiline
                  rows={3}
                  value={finalinspectionsORtestsConducted}
                  onChange={(e) =>
                    setFinalinspectionsortestsConducted(e.target.value)
                  }
                  variant="outlined"
                />
              </Grid>
              <Grid item sx={{ width: "500px" }}>
                <Typography
                  variant="subtitle1"
                  sx={{ mb: 3.3, fontWeight: "medium", mt: 3 }}
                >
                  2. Are final inspection records kept?
                </Typography>
                <TextField
                  fullWidth
                  multiline
                  rows={3}
                  value={finalinspectionrecordskept}
                  onChange={(e) =>
                    setFinalinspectionrecordsKept(e.target.value)
                  }
                  variant="outlined"
                />
              </Grid>
              <Grid item sx={{ width: "500px" }}>
                <Typography
                  variant="subtitle1"
                  sx={{ mb: 1, fontWeight: "medium" }}
                >
                  3. Do the final inspection records include the name or
                  identification of the person who performed the inspection?
                </Typography>
                <TextField
                  fullWidth
                  multiline
                  rows={3}
                  value={finalinspectionrecordsinclude}
                  onChange={(e) =>
                    setFinalinspectionRecordsInclude(e.target.value)
                  }
                  variant="outlined"
                  sx={{ mb: 2 }}
                />
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>
        {/* Clause 8.7:  Non-conforming product  */}
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            sx={{
              backgroundColor: "#f5f5f5",
              borderBottom: "1px solid #e0e0e0",
            }}
          >
            <Typography variant="h6">
              Clause 8.7: Non-conforming product{" "}
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Grid container spacing={3}>
              <Grid item sx={{ width: "500px" }}>
                <Typography
                  variant="subtitle1"
                  sx={{ mb: 1, fontWeight: "medium", mt: 2 }}
                >
                  1.Are nonconforming products properly identified and
                  controlled in some manner to ensure they are not accidentally
                  used or shipped?
                </Typography>
                <TextField
                  fullWidth
                  multiline
                  rows={3}
                  value={nonconformingproductsproperlyidentified}
                  onChange={(e) =>
                    setnonConformingProductsproperlyidentified(e.target.value)
                  }
                  variant="outlined"
                />
              </Grid>
              <Grid item sx={{ width: "500px" }}>
                <Typography
                  variant="subtitle1"
                  sx={{ mb: 1, fontWeight: "medium", mt: 2 }}
                >
                  2. Does the company notify customers if a nonconforming
                  product is discovered after it has been delivered?
                </Typography>
                <TextField
                  fullWidth
                  multiline
                  rows={3}
                  value={doesthecompanynotifycustomers}
                  onChange={(e) =>
                    setdoesThecompanyNotifycustomers(e.target.value)
                  }
                  variant="outlined"
                />
              </Grid>
              <Grid item sx={{ width: "500px" }}>
                <Typography
                  variant="subtitle1"
                  sx={{ mb: 2.7, fontWeight: "medium", mt: 2 }}
                >
                  3. Is nonconforming product dealt with by one or more of the
                  following ways: corrected, contained, segregated, reworked,
                  repaired or accepted as is?
                </Typography>
                <TextField
                  fullWidth
                  multiline
                  rows={3}
                  value={nonconformingproductdealtwith}
                  onChange={(e) =>
                    setnonConformingproductDealtwith(e.target.value)
                  }
                  variant="outlined"
                />
              </Grid>
              <Grid item sx={{ width: "500px" }}>
                <Typography
                  variant="subtitle1"
                  sx={{ mb: 5, fontWeight: "medium", mt: 3 }}
                >
                  4. Is nonconforming product segregated or contained, to ensure
                  it does not cross-contaminate conforming products?
                </Typography>
                <TextField
                  fullWidth
                  multiline
                  rows={3}
                  value={nonconformingproductsegregatedor}
                  onChange={(e) =>
                    setnonConformingProductsegregatedor(e.target.value)
                  }
                  variant="outlined"
                />
              </Grid>
              <Grid item sx={{ width: "500px" }}>
                <Typography
                  variant="subtitle1"
                  sx={{ mb: 2.6, fontWeight: "medium", mt: 2 }}
                >
                  5. Is the customer notified when applicable?
                </Typography>
                <TextField
                  fullWidth
                  multiline
                  rows={3}
                  value={customernotifiedwhenapplicable}
                  onChange={(e) =>
                    setcustomerNotifiedWhenapplicable(e.target.value)
                  }
                  variant="outlined"
                />
              </Grid>
              <Grid item sx={{ width: "500px" }}>
                <Typography
                  variant="subtitle1"
                  sx={{ mb: 2.6, fontWeight: "medium", mt: 2 }}
                >
                  6. If a product is reworked or repaired, is it then
                  re-inspected?
                </Typography>
                <TextField
                  fullWidth
                  multiline
                  rows={3}
                  value={productisreworkedorrepaired}
                  onChange={(e) =>
                    setproductisREworkedORrepaired(e.target.value)
                  }
                  variant="outlined"
                />
              </Grid>
              <Grid item sx={{ width: "500px" }}>
                <Typography
                  variant="subtitle1"
                  sx={{ mb: 3.5, fontWeight: "medium", mt: 1 }}
                >
                  7. Are records of the nonconformities maintained?
                </Typography>
                <TextField
                  fullWidth
                  multiline
                  rows={3}
                  value={recordsofthenonconformities}
                  onChange={(e) =>
                    setrecordsOFthenonConformities(e.target.value)
                  }
                  variant="outlined"
                />
              </Grid>
              <Grid item sx={{ width: "500px" }}>
                <Typography
                  variant="subtitle1"
                  sx={{ mb: 1, fontWeight: "medium" }}
                >
                  8. Do these records include the actions taken, customer
                  approvals or waivers received, and the person(s) authorizing
                  the final disposition?
                </Typography>
                <TextField
                  fullWidth
                  multiline
                  rows={3}
                  value={customerapprovalsorwaivers}
                  onChange={(e) =>
                    setcustomerApprovalsORwaivers(e.target.value)
                  }
                  variant="outlined"
                  sx={{ mb: 2 }}
                />
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>

        {/* Clause 9.1:  Business performance  */}
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            sx={{
              backgroundColor: "#f5f5f5",
              borderBottom: "1px solid #e0e0e0",
            }}
          >
            <Typography variant="h6">
              Clause 9.1: Business performance
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Grid container spacing={3}>
              <Grid item sx={{ width: "500px" }}>
                <Typography
                  variant="subtitle1"
                  sx={{ mb: 1, fontWeight: "medium", mt: 2 }}
                >
                  1. Are methods underway to monitor and measure customer
                  satisfaction?
                </Typography>
                <TextField
                  fullWidth
                  multiline
                  rows={3}
                  value={methodsunderwaytomonitor}
                  onChange={(e) => setmethodsUnderwayTomonitor(e.target.value)}
                  variant="outlined"
                />
              </Grid>
              <Grid item sx={{ width: "500px" }}>
                <Typography
                  variant="subtitle1"
                  sx={{ mb: 2.2, fontWeight: "medium", mt: 4 }}
                >
                  2. Is the company measuring product quality data?
                </Typography>
                <TextField
                  fullWidth
                  multiline
                  rows={3}
                  value={companymeasuringproduct}
                  onChange={(e) => setcompanyMeasuringProduct(e.target.value)}
                  variant="outlined"
                />
              </Grid>
              <Grid item sx={{ width: "500px" }}>
                <Typography
                  variant="subtitle1"
                  sx={{ mb: 1, fontWeight: "medium", mt: 0 }}
                >
                  3. Is the company measuring process KPIs or objectives?
                </Typography>
                <TextField
                  fullWidth
                  multiline
                  rows={3}
                  value={companykpi}
                  onChange={(e) => setcompanyKpi(e.target.value)}
                  variant="outlined"
                  sx={{ mb: 2 }}
                />
              </Grid>
              <Grid item sx={{ width: "500px" }}>
                <Typography
                  variant="subtitle1"
                  sx={{ mb: 1, fontWeight: "medium" }}
                >
                  4. Are suppliers being measured in terms of performance?
                </Typography>
                <TextField
                  fullWidth
                  multiline
                  rows={3}
                  value={suppliersbeingmeasured}
                  onChange={(e) => setsuppliersBeingMeasured(e.target.value)}
                  variant="outlined"
                  sx={{ mb: 2 }}
                />
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>

        <Box sx={{ pt: 5 }}>
          <GlobalButton
            sx={{ mr: 2 }}
            variant="contained"
            icon={<SaveIcon />}
            onClick={handleSave}
            disabled={submitting} // Disable button while submitting
          >
            {submitting ? "Saving..." : "Save"}
          </GlobalButton>
          <GlobalButton
            variant="outlined"
            onClick={onClose}
            icon={<RestartAltIcon />}
          >
            RESET
          </GlobalButton>
        </Box>
        {/* Add the CAR Dialog component */}
        <CARCreateDialog
          open={carDialogOpen}
          onClose={() => setCarDialogOpen(false)}
          formData={carFormData}
          handleInputChange={handleCarInputChange}
          //fetchCARData={fetchCARData}
        />
      </Box>
    </Dialog>
  );
}
